import React, { useEffect, useState, useRef } from 'react';

function DivWithText({
                       x,
                       y,
                       width,
                       height,
                       oldTopLeftX,
                       oldTopLeftY,
                       widthRatio,
                       heightRatio,
                       text,
                       index,
                       onChange,
                       onResize,
                       onClose,
                       disabled = false,
                       focus = false,
                     }) {
  const dragState = {
    diffX: 0,
    diffY: 0,
    styles: {}
  }

  const [textareaStyle] = useState({
    position: 'initial',
    left: x,
    top: y,
    width: width,
    height: height,
    // resize: disabled ? 'none' : 'both',
    resize: 'both',
    fontSize: disabled ? '11px' : '13px',
    backgroundColor: disabled ? 'yellow' : 'white',
    color: disabled ? 'red' : 'blue',
    border: '1px solid black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  });

  const [containerDivStyle, setContainerDivStyle] = useState({
    zIndex: 2,
    position: 'absolute',
    left: x,
    left2: oldTopLeftX,
    top: y,
    top2: oldTopLeftY,
    width: width,
    height: height,
    backgroundColor: 'transparent',
  });

  const dragStart = (e) => {
    dragState.diffX = e.pageX;
    dragState.diffY = e.pageY;

    document.addEventListener('mousemove', dragging);
    document.addEventListener('mouseup', dragEnd);
  }

  const dragging = (e) =>{
    if (disabled) {
      return;
    }

    var el = document.getElementById(`textArea${index}`);
    var style = el.style;
    var left = containerDivStyle.left + (e.pageX - dragState.diffX);
    var top = containerDivStyle.top + (e.pageY - dragState.diffY);

    if (left < 0) {
      left = 0;
    }

    if (top < 0) {
      top = 0;
    }

    var parentRect = el.parentNode.getBoundingClientRect();
    var parentWidth = parentRect.width;
    var parentHeight = Math.floor(parentRect.height);
    var width = parseInt(style.width);
    var height = parseInt(style.height);

    if ((left + width) >= parentWidth) {
      left = parentWidth - (width + 4);
    }

    if ((top + height) >= parentHeight) {
      top = parentHeight - (height + 9);
    }

    let top2 = top +  (top-  top* heightRatio) + 3
    let left2 = left +  (left -  left* widthRatio)  + 6
    style.left = left + "px"
    style.top = top + "px"

    setContainerDivStyle((oldData) => {
      return {
        ...oldData,
        left: left,
        left2: left2,
        top: top ,
        top2 : top2,
      };
    });
  }

  const dragEnd = (e) =>{
    document.removeEventListener('mousemove', dragging);
    document.removeEventListener('mouseup', dragEnd);
  }

  const [value, setValue] = useState(text);
  const [isHovering, setIsHovering] = useState(false);
  const [widthHeight, setWidthHeight] = useState({ width, height });

  const handleMouseEnter = (e) => {
    setIsHovering(true);
  };

  const handleMouseLeave = (e) => {
    setIsHovering(false);
  };

  const textareaRef = useRef(null);

  useEffect(() => {
    const textarea = textareaRef?.current;

    if (!textarea) return;

    if (focus) {
      textarea.focus();
    }

    const resizeObserver = new ResizeObserver((entries) => {
      if (width === entries[0].contentRect.width && height === entries[0].contentRect.height) {
        return;
      }
      handleResize(entries[0].contentRect);
    });

    resizeObserver.observe(textarea);

    return () => {
      // Cleanup the resizeObserver by unobserving all elements
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    setValue(text);
  }, [text]);

  useEffect(() => {
    if (onResize) {
      onResize(index, getVertices());
    }
  }, [index, containerDivStyle]);

  const handleChange = (event) => {
    if (disabled) {
      return;
    }
    setValue(event.target.value);
    onChange(index, event.target.value);
  };
  const handleCloseClick = () => {
    onClose(index);
    setIsHovering(false);
  };
  const handleResize = ({ width, height }) => {
    // console.log('Canvas handleResize: ');
    if (disabled) {
      return;
    }

    setContainerDivStyle((oldData) => {
      return {
        ...oldData,
        width: width,
        height: height,
      };
    });
    setWidthHeight({ width, height });
  };

  const getVertices = () => {
    const vertices = [
      {
        x: containerDivStyle.left2,
        y: containerDivStyle.top2,
      },
      {
        x: containerDivStyle.left2 + containerDivStyle.width/ widthRatio,
        y: containerDivStyle.top2,
      },
      {
        x: containerDivStyle.left2 + containerDivStyle.width/ widthRatio,
        y: containerDivStyle.top2 + containerDivStyle.height/ heightRatio,
      },
      {
        x: containerDivStyle.left2,
        y: containerDivStyle.top2 + containerDivStyle.height/ heightRatio,
      }
    ];

    return vertices;
  };

  return (
      <div id={"textArea"+index} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={containerDivStyle}>
        {isHovering && !disabled && (
            <button
                onClick={handleCloseClick}
                style={{
                  position: 'absolute',
                  top: '-12px',
                  left: `${widthHeight.width - 6}px`,
                  opacity: '0.9',
                  backgroundColor: '#c90401',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '1.5rem',
                  height: '1.5rem',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
            >
              X
            </button>
        )}

        {isHovering && !disabled && (
            <button
                onMouseDown={dragStart}
                style={{
                  position: 'absolute',
                  top: '-20px',
                  left: `${widthHeight.width - widthHeight.width}px`,
                  opacity: '0.9',
                  backgroundColor: '#838383',
                  color: 'white',
                  border: 'none',
                  width: '4rem',
                  height: '1.5rem',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
            >
              drag
            </button>
        )}
        <textarea
            ref={textareaRef}
            placeholder={disabled ? '' : 'Text를 입력해주세요.'}
            style={textareaStyle}
            type="text"
            value={value}
            onChange={handleChange}
            disabled={disabled}
        />
      </div>
  );
}
export default DivWithText;
